import styled, { css } from 'styled-components';

export const CategoryButton = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  height: 34px;
  padding: 0 16px 0 5px;
  border-radius: 999px;
  border: 1px solid var(--gray-light);
  background: var(--color-white);
  color: var(--gray-darker);
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition:
    border-color 160ms ease,
    background 160ms ease,
    color 160ms ease,
    transform 160ms ease,
    box-shadow 160ms ease;

  .rioglyph {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 999px;
    background: var(--gray-lightest);
    color: var(--brand-primary);
    font-size: 13px;
    transition:
      background 160ms ease,
      color 160ms ease;
  }

  &:hover:not([aria-disabled='true']) {
    border-color: var(--brand-primary);
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(0, 171, 169, 0.14);
  }

  //INFO: Inoperable controls are aria-disabled rather than disabled so they stay focusable and
  //announced. They are therefore still active controls, so WCAG 1.4.3 applies and the state is shown
  //with a muted palette that keeps 4.5:1 rather than with opacity.
  &[aria-disabled='true'] {
    background: var(--gray-lightest);
    color: var(--gray-darker);
    cursor: not-allowed;

    .rioglyph {
      background: var(--color-white);
      color: var(--gray-darker);
    }
  }

  ${({ $active }) =>
    $active &&
    css`
      background: var(--brand-primary);
      border-color: var(--brand-primary);
      color: var(--color-white);
      box-shadow: 0 4px 14px rgba(0, 171, 169, 0.28);

      .rioglyph {
        background: rgba(255, 255, 255, 0.22);
        color: var(--color-white);
      }
    `}
`;
